import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useStaffMeQuery } from "../api";
import usertour from "usertour.js";
import { useUsertourEventPropagationFix } from "./useUsertourEventPropagationFix";

export const useUsertour = () => {
  const navigate = useNavigate();
  const { data: { result: user } = {} } = useStaffMeQuery();
  const initializationRef = useRef(false);
  const userIdentifiedRef = useRef<string | null>(null);

  const usertourToken = import.meta.env.VITE_USERTOUR_TOKEN;

  const { startObserver, stopObserver } = useUsertourEventPropagationFix();

  useEffect(() => {
    if (usertourToken && !initializationRef.current) {
      usertour.init(usertourToken);
      startObserver();
      usertour.setCustomNavigate((url: string) => navigate(url));
      initializationRef.current = true;
    }

    return () => {
      stopObserver();
    };
  }, [usertourToken, navigate, startObserver, stopObserver]);

  useEffect(() => {
    if (
      user &&
      initializationRef.current &&
      userIdentifiedRef.current !== user.id
    ) {
      const userId = user.id;

      usertour.identify(userId, {
        name: `${user.first_name} ${user.last_name}`,
      });

      userIdentifiedRef.current = userId;
    }
  }, [user]);

  useEffect(() => {
    if (!user && userIdentifiedRef.current) {
      usertour.reset();
      userIdentifiedRef.current = null;
    }
  }, [user]);
};
